import { useSubscribe } from "@app/shared/hooks/useSubscribe";
import { isImmersiveChallengeRoute } from "@core/shared/utils/immersive-routes";
import { SubmitButton } from "@design-system/components/Button";
import { EmailInput } from "@design-system/components/Form";
import { trans, plainTrans } from "@mongez/localization";
import { Form } from "@mongez/react-form";
import { useLocation } from "@remix-run/react";

export function SubscribeToNewsletter() {
  const { handleSubscribe } = useSubscribe();
  const location = useLocation();

  if (location.search.includes("noLayout")) {
    return null;
  }

  if (isImmersiveChallengeRoute(location.pathname)) {
    return null;
  }

  return (
    <section className="border-t border-gray-200 bg-white pb-10 pt-6 dark:border-gray-700 dark:bg-gray-800">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center justify-center gap-6 sm:flex-row sm:gap-8">
          <div className="text-center sm:text-start">
            <h2 className="text-lg font-medium text-gray-900 dark:text-gray-100">
              {trans("subscribeToOurNewsletter")}
            </h2>
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
              {trans("stayUpToDateWithLatestNews")}
            </p>
          </div>
          <Form onSubmit={handleSubscribe} className="w-full max-w-sm">
            <div className="flex items-start gap-x-2">
              <EmailInput
                name="email"
                placeholder={plainTrans("enterYourEmail")}
                required
                className="flex-1"
              />
              <SubmitButton
                size="sm"
                className="shrink-0 translate-y-2"
                title={plainTrans("subscribe")}
              >
                {trans("subscribe")}
              </SubmitButton>
            </div>
          </Form>
        </div>
      </div>
    </section>
  );
}
